import { EventApi } from '@fullcalendar/core';
import { addDays, startOfDay } from 'date-fns';

// The grid gets `isPast` from FullCalendar for free; surfaces that render events
// outside the grid (the "+N more" popover) need to recompute it the same way.
// All-day events run until the day ends, so they only read as past once the day
// itself has passed — FullCalendar reports no `end` for them, so mirror the grid
// by treating their end as the start of the next day. Timed events use their real
// end, falling back to their start when open-ended.
export const getEventIsPast = (
  event: Pick<EventApi, 'allDay' | 'start' | 'end'>,
  now: Date,
): boolean => {
  const eventEnd =
    event.allDay && event.start
      ? addDays(startOfDay(event.start), 1)
      : event.end ?? event.start;

  return !!eventEnd && eventEnd.getTime() <= now.getTime();
};
